import { Injectable } from "@angular/core";
import { Observable, catchError, from, map, of } from "rxjs";
import { Share, ShareResult } from "@capacitor/share";

@Injectable({ providedIn: "root" })
export class ShareMessageCapacitor {
  execute(message: string, url: string): Observable<string> {
    return from(
      Share.share({
        text: message,
        url: url,
      })
    ).pipe(
      map((share: ShareResult) =>
        !!share.activityType ? share.activityType : ""
      ),
      catchError((err) => of("error not catched"))
    );
  }
}
